<template>

  <div class="d-container sendi-admin-entry">

    <div class="d-content">

      <div class="login-header text-center">

        <button type="button" class="return-login" @click="backPage">
          <img src="/static/img/flecha.svg" alt="">
          <span>Volver</span>
        </button>

        <span class="title-login">
          <img class="logo-login" src="/static/img/sendi-logo.png" width="400" height="78" alt="Sendi">
        </span>
<!--
        <span v-if="role==1" class="sub-login">Ingrese como administrador general</span>
        <span v-if="role==2" class="sub-login">Ingrese como operador de envío o recepción</span>
        <span v-if="role==3" class="sub-login">Ingrese como cliente</span> -->

      </div>



      <div id="login" :class="tipologin">
        <!-- <img src="/static/img/logo.png" class="center-block logo"> -->

        <div class="text-center" id="form-container">
          <!-- login form -->
          <div id="form-login">
            <router-view></router-view>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      tipologin: '',
      role: ''
    }
  },
  mounted() {
    // if (this.$route.params.id === 'admin') {
    //   this.tipologin = 'login-bg-admin'
    //   this.role = 1
    // } else if (this.$route.params.id === 'oper') {
    //   this.tipologin = 'login-bg-oper'
    //   this.role = 2
    // } else {
    //   this.tipologin = 'login-bg-client'
    //   this.role = 3
    // }
  },
  methods:{
    backPage(){
      this.$router.go(-1);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Login.vue?5a025315